import { createSlice, current } from '@reduxjs/toolkit';
import { captureException } from '@sentry/react';
import { isShallowIdentical } from 'utils/isShallowIdentical';

import { fetchSettings } from './settings.thunks';
import type { IDexfSettings } from '@inter-ikea-kompis/types/lib';

type SkyttaSettings = {
  plannerBannerMessageType: string;
  plannerBannerMessageTypeKiosk: string;
  plannerBannerMessageEnabled: boolean;
  plannerBannerMessageEnabledKiosk: boolean;
  skyttaSupportBookingEnabled: boolean;
  bannerMessages: string;
};

export interface IAppSettings extends IDexfSettings {
  vpc: any;
  skytta: SkyttaSettings;
}

export type TAppSettings = IAppSettings;

type SettingsStates = {
  appSettings: IAppSettings | null;
};

const initialState: SettingsStates = {
  appSettings: null
};

export const { reducer: settingsReducer } = createSlice({
  name: 'settings',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.fulfilled, (state, { payload: appSettings }) => {
        if (isShallowIdentical(current(state).appSettings, appSettings)) {
          return;
        }

        return {
          ...state,
          appSettings
        };
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        const error = new Error();
        error.name = 'Failed to fetch settings data';
        error.message = action.error.message || '';

        captureException(error, (scope) => {
          scope.setExtra('state', state);
          scope.setExtra('action', action);
          return scope;
        });
      });
  },
  reducers: {}
});
